(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["chief-categories"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){var link=event.target.closest('[data-chief-category],[data-chief-goal]');if(!link)return;var field=link.hasAttribute('data-chief-category')?document.querySelector('[data-chief-category-field]'):document.querySelector('[data-chief-goal-field]');if(field){field.value=link.getAttribute('data-chief-category')||link.getAttribute('data-chief-goal');field.dispatchEvent(new Event('change',{bubbles:true}));}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chief-header"]) return;
  try {
    
document.addEventListener('click',function(event){var link=event.target.closest('.chief-mobile-menu a');if(link){link.closest('details').open=false;}});
document.addEventListener('keydown',function(event){if(event.key==='Escape'){document.querySelectorAll('.chief-mobile-menu[open]').forEach(function(menu){menu.open=false;menu.querySelector('summary').focus();});}});

  } catch(e) { console.error(e); }
})();
})();
